import { all, takeLatest, call, put } from "redux-saga/effects";
import {
  SET_TRANSFER,
  SET_TRANSFER_SUCCESS,
  SET_TRANSFER_FAILED,
  SET_TRANSFER_DUPLICATED,
  SET_FNZ_TIMEOUT,
} from "./constant";
import * as api from "../../../utils/api";
import { API_URL } from "../../../utils/axios";
import { OE_00005, TA_504 } from "../../../utils/errorCodes";

function* transferSaga(action) {
  try {
    const res = yield call(api.post, `${API_URL.mp}/transfer`, action.payload);

    if (
      res instanceof Error ||
      (typeof res === "object" &&
        (!("status" in res) || (res.status === 200 && res.data === "")))
    ) {
      throw new Error(res);
    }

    const { data } = res;

    yield put({ type: SET_TRANSFER_SUCCESS, payload: data });
    if ("callback" in action && typeof action.callback === "function") {
      action.callback();
    }
  } catch (error) {
    // OE-00005 is the error code for duplicate transaction, which is returned from backend when duplicate transaction is detected
    if (error?.errorCode === OE_00005) {
      yield put({
        type: SET_TRANSFER_DUPLICATED,
      });
    } /* else if (error?.errorCode === OE_00006) {
      yield put({
        type: SET_TRANSACTION_TIMEOUT,
      });
    } */ else if (
      error?.errorCode === TA_504
    ) {
      // Handle FNZ Timeout error, which is returned from backend when FNZ service is timeout
      yield put({
        type: SET_FNZ_TIMEOUT,
      });
    } else {
      yield put({ type: SET_TRANSFER_FAILED, payload: Boolean(error) });
    }
  }
}

export function* switchingWorkerSaga() {
  yield all([takeLatest(SET_TRANSFER, transferSaga)]);
}
